export default __webpack_public_path__ + "static/imgHome-667d0a33488aa8bcbe803761fac05714.webp";